"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var WithErrorHandler_1 = require("../../components/WithErrorHandler");
var Index = function (props) {
    var productInfo = react_1.useMemo(function () { return props.productInfo || {}; }, [JSON.stringify(props.productInfo)]);
    var onShowSelectProdPop = function () {
        if (typeof props.autoClickProArea == 'function') {
            props.autoClickProArea(props.productInfo);
            return;
        }
        if (typeof props.showSelectPop === 'function') {
            props.showSelectPop();
        }
    };
    var handlerPrice = function (price) {
        if (isNaN(parseFloat(price))) {
            return "暂无价格";
        }
        if (price.toString().indexOf("万") != -1) {
            return price + "起";
        }
        return price + "万起";
    };
    if (!productInfo) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return (react_1.default.createElement("div", { className: "newcar-default-product " + (typeof props.showSelectPop === 'function' ? 'show-more' : '') + " " + (typeof props.autoClickProArea === 'function' ? 'show-more' : ''), onClick: onShowSelectProdPop },
        react_1.default.createElement("img", { src: productInfo.guidePic ||
                '//icon.xgo-img.com.cn/apps/21112915/home_default_line_pic.png', alt: '' }),
        react_1.default.createElement("div", { className: 'right-product-info' },
            react_1.default.createElement("div", { className: "product-title " + (!productInfo.showName ? 'no-data-area' : '') }, productInfo.showName || ''),
            react_1.default.createElement("div", { className: "product-price " + (!productInfo.showPrice ? 'no-data-area' : '') }, productInfo.showPrice ? (react_1.default.createElement(react_1.default.Fragment, null,
                "\u53C2\u8003\u4EF7",
                ' ',
                react_1.default.createElement("span", null, handlerPrice(productInfo.showPrice)))) : ('')))));
};
exports.default = WithErrorHandler_1.WithErrorHandler(react_1.memo(Index));
